import React from 'react';
import { Card, Skeleton, Space } from 'antd';

export const WeatherSkeleton = () => {
  return (
    <div className="weather-skeleton-wrap" style={{ width: '100%', marginTop: 8 }}>
      {/* Header: Title + Edit List Button */}
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: 16,
          flexWrap: 'wrap',
          gap: 12,
        }}
      >
        <Skeleton.Input active style={{ width: 180, height: 28, borderRadius: 4 }} />
        <Skeleton.Button active style={{ width: 190, height: 36, borderRadius: 6 }} />
      </div>

      {/* Weather Filter Bar: Date Range + Region TreeSelect */}
      <div
        style={{
          display: 'flex',
          gap: 16,
          alignItems: 'center',
          marginBottom: 20,
          flexWrap: 'wrap',
        }}
      >
        <Skeleton.Input active style={{ width: 240, height: 38, borderRadius: 6 }} />
        <Skeleton.Input active style={{ width: 280, height: 38, borderRadius: 6 }} />
      </div>

      {/* Main Weather Card / Hero */}
      <Card
        style={{
          borderRadius: 8,
          border: '1px solid #eaedf1',
          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.04)',
          marginBottom: 20,
          background: '#ffffff',
        }}
        bodyStyle={{ padding: '24px' }}
      >
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            flexWrap: 'wrap',
            gap: 20,
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: 20 }}>
            <Skeleton.Avatar active size={72} shape="square" style={{ borderRadius: 12 }} />
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              <Skeleton.Input active style={{ width: 120, height: 38, borderRadius: 6 }} />
              <Skeleton.Input active size="small" style={{ width: 180, height: 16, borderRadius: 4 }} />
            </div>
          </div>

          <div style={{ display: 'flex', gap: 24, flexWrap: 'wrap' }}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
              <Skeleton.Input active size="small" style={{ width: 80, height: 14, borderRadius: 4 }} />
              <Skeleton.Input active size="small" style={{ width: 110, height: 20, borderRadius: 4 }} />
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
              <Skeleton.Input active size="small" style={{ width: 80, height: 14, borderRadius: 4 }} />
              <Skeleton.Input active size="small" style={{ width: 110, height: 20, borderRadius: 4 }} />
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
              <Skeleton.Input active size="small" style={{ width: 80, height: 14, borderRadius: 4 }} />
              <Skeleton.Input active size="small" style={{ width: 110, height: 20, borderRadius: 4 }} />
            </div>
          </div>
        </div>
      </Card>

      {/* Hourly / Daily Accordion Forecast Skeletons */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
        {Array.from({ length: 5 }).map((_, idx) => (
          <div
            key={'weather_row_' + idx}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              padding: '14px 20px',
              backgroundColor: '#ffffff',
              border: '1px solid #eaedf1',
              borderRadius: 8,
              boxShadow: '0 1px 2px rgba(0,0,0,0.02)',
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: 18 }}>
              <Skeleton.Input active size="small" style={{ width: 60, height: 16, borderRadius: 4 }} />
              <Skeleton.Avatar active size={36} shape="circle" />
              <Skeleton.Input active size="small" style={{ width: 50, height: 24, borderRadius: 4 }} />
              <Skeleton.Input active size="small" style={{ width: 140, height: 16, borderRadius: 4 }} />
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
              <Skeleton.Input active size="small" style={{ width: 80, height: 16, borderRadius: 4 }} />
              <Skeleton.Button active size="small" shape="circle" style={{ width: 20, height: 20 }} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default WeatherSkeleton;

